<template>
    <div class="frcuc-container" style="width: 330px !important" @click="handleSelection">

        <!--Profile image | User details | Checkbox-->
        <div class="frcuc-details-container">
            <v-row class="pa-0 ma-0 align-center" style="width: 100% !important">
                <v-col cols="3" class="align-center">
                    <v-icon class="align-center icons8-circle" color="grey" size="40"/>
                </v-col>

                <v-col cols="9" class="pa-0 ma-0">
                    <v-row>
                        <app-text category="text-default-bold" class="black--text text-capitalize">{{ user.userName }}
                            <v-icon v-if="user.userIsFireMarshall" class="icons8-fire mr-2 mb-1" color="error" size="20"/>
                            <v-icon v-if="user.userIsFirstAider" class="icons8-clinic mb-1" color="success" size="20"/>
                        </app-text>
                    </v-row>
                    <v-row>
                            <div class="font-weight-bold body-2 darkgrey--text">{{ user.userType }}</div>
                    </v-row>
                    <v-row>
                            <div class="font-weight-bold caption grey--text">{{ user.organisation.organisationName }}</div>
                    </v-row>
                    <v-row>
                        <div class="d-flex align-end mt-0">
                            <!-- <v-icon class="icons8-qr-code mr-1" size="32" :color="computedSwappStatus.color"/> -->
                            <app-text category="text-default-bold">{{ computedSwappStatus.label }}<span :class="computedSwappTime.color" class="font-weight-regular ml-2">Today at {{ this.$moment(user.swappedTime, 'X').format('HH:mm') }}</span> </app-text>
                        </div>
                    </v-row>
                    <!--Flags for records that may not reflect who is on site-->
                    <v-row v-if="computedAccountStatus || computedSwappedInTooLong">
                        <div class="d-flex flex-wrap align-center mt-1">
                            <v-chip v-if="computedAccountStatus" class="warning white--text mr-1" x-small>{{ computedAccountStatus }}</v-chip>
                            <v-chip v-if="computedSwappedInTooLong" class="error white--text" x-small>{{ computedSwappedInTooLong }}</v-chip>
                        </div>
                    </v-row>
                </v-col>
            </v-row>
        </div>


    </div>
</template>

<script>
export default {

    name: "fireRollCallUserCardPrint",

    props: ['user'],

    data: () => ({

        imageSize: 88,
        isUserChecked: false,

    }),

    computed: {

        /** * Computed Swapp Status * * Return a color and label to signify if a user is SWAPPed in or out. * * @returns {{color: string, label: string}} */
        computedSwappStatus() {
            const t = this
            const swappStatus = t.$props.user.swappStatus
            let color = ''
            let label = ''

            if (swappStatus) {
                color = 'success'
                label = 'IN'
            } else {
                color = 'lightgrey'
                label = 'OUT'
            }

            return {color: color, label: label}
        },

        /** * Computed Swapp Time * * Calculate if the current user has ever SWAPPed in/out, if they have and it was today, * return the date and time. * If they have not, return a message. * * @returns {{color, label: string}} either the date and time, or a message */
        computedSwappTime() {
            const t = this
            let lastSwappDateTime
            let color

            // If the user has a last swapp dateTime
            if (t.$props.user.lastSwappDateTime) {

                // Grab a reference to the last SWAPP datetime
                const lastSwapp = t.$props.user.lastSwappDateTime

                // Grab a reference to the date now
                const dateTimeNow = t.$moment().format('DD/MM/YYYY')

                // If the last swapp dateTime was today, assign the date and time
                if (dateTimeNow === t.$moment(Number(lastSwapp)).format('DD/MM/YYYY')) {
                    color = 'grey'
                    lastSwappDateTime = 'Today ' + t.$moment(Number(lastSwapp)).format('@ HH:mm')
                }
                // If there is no SWAPP for today, render a message
                else {
                    color = 'grey'
                    lastSwappDateTime = 'More than a day ago'
                }
            }
            // If the user has never SWAPPed, render a message
            else {
                color = 'grey'
                lastSwappDateTime = 'More than a day ago'
            }
        

            return {label: lastSwappDateTime, color: color + '--text'}

        },
        /** * Computed Account Status * * Return the user's account status if it isn't APPROVED, so it can be flagged on the roll call. * * @returns {string} */
        computedAccountStatus() {
            const userStatus = this.$props.user.userStatus
            return userStatus && userStatus !== 'APPROVED' ? userStatus : ''
        },
        /** * Computed Swapped In Too Long * * Flag a user who has been SWAPPed in longer than the 13 hour auto swap-out, or has no SWAPP time. * * @returns {string} label, or empty if the user isn't flagged */
        computedSwappedInTooLong() {
            const t = this
            if (parseInt(t.$props.user.swappStatus) !== 1) return ''

            const swappedTime = t.$moment(t.$props.user.swappedTime, 'X')
            if (!t.$props.user.swappedTime || !swappedTime.isValid()) return 'No SWAPP in time'
            if (t.$moment().diff(swappedTime, 'hours') < 13) return ''

            return 'In for ' + swappedTime.fromNow(true)
        }

    },

    methods: {
        /** * Handle Selection * * Toggle the isUserChecked property for the checkbox colouring. * Emit the selected User back to the parent (fireRollCallRegister.vue). */
        handleSelection() {
            const t = this

            t.isUserChecked = !t.isUserChecked

            t.$emit('fireRollCallSelection', t.$props.user)
        },
        /** * Call User * * Open a telephone prompt to call the selected User. */
        callUser() {
            window.open('tel:' + this.$props.user.userTelephone)
        }

    },

    mounted() {
        const t = this
        t.isUserChecked = !!t.$props.user.checked
    }

}
</script>

<style>
.frcuc-container {
    display: flex;
    flex-direction: column;

    background: white;
    border-radius: 5px;
    padding: 8px;

    animation: fadeIn 1s;
}

.frcuc-details-container {
    display: flex;
}

.frcuc-profileImage {
    border-radius: 5px;
}

.frcuc-greyScaleImage {
    filter: grayscale(100%);
}

</style>